import { invalidInstantiation } from './invalid-instantiation';
import { PrimitiveValue } from './primitive-value';

export class NotEmptyStringValue extends PrimitiveValue<string> {
  protected value: string;

  constructor(value: string | null | undefined) {
    if (value === undefined) {
      throw new TypeError(
        `${invalidInstantiation}: NotEmptyStringValue was given undefined`,
      );
    }
    if (value === null) {
      throw new TypeError(
        `${invalidInstantiation}: NotEmptyStringValue was given null`,
      );
    }
    if (value.length === 0) {
      throw new TypeError(
        `${invalidInstantiation}: NotEmptyStringValue was given blank string`,
      );
    }

    super(value);
    this.value = value;
  }

  toString(): string {
    return this.value;
  }
}
